module.exports = __webpack_public_path__ + "img/DSC_3009.00d93de4.jpg";